module.exports = __webpack_public_path__ + "img/rpg_1.23762995.jpeg";